module.exports = __webpack_public_path__ + "img/tuijianchapin.160d3f04.png";